import React from 'react'

import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
function PrivateRoute() {
    //const { isAuthenticated } = useAuth();
    
    let isAuthenticate=false//to check the authentication of user
    const currentTime = new Date().toLocaleString();
    const tokenExpirationTime=new Date(sessionStorage.getItem('tokenExpirationTime')).toLocaleString()
    //isAuthenticate is set to true if token is available in the sessionStorage and the access_token is not expired
    if(sessionStorage.getItem('access_token') || sessionStorage.getItem('refresh_token')){
      
      if(tokenExpirationTime && tokenExpirationTime>=currentTime){
         isAuthenticate=true
      //if the token is expired isAuthenticate is set to false and sessionStorage is cleared
      }else{   
         isAuthenticate=false
        //  toast.error('Token expired please login again')
         sessionStorage.removeItem('access_token');
         sessionStorage.removeItem('refresh_token');
         sessionStorage.removeItem('user_id');
         sessionStorage.removeItem('tokenExpirationTime');
      }
    }
    //isAuthenticate is set to false if the token is not available in sessionStorage
    else{
      isAuthenticate=false
    }
    //console.log(isAuthenticate)
    //if the user is authenticated then the page is displayed otherwise user is redirected to login page
    if (isAuthenticate){
    return (
        <Outlet/>
        )}
    else{
      
      return(  <Navigate to={'/skyblue'}/>)
    }

}

export default PrivateRoute